import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { getTheme } from '../../../src/theme/getTheme'

export const getFriendsListStyles = (theme: Theme) => StyleSheet.create({
  container: {
    flex: 1,
    width: '100%', // Ensure full width usage
  },
  section: {
    marginBottom: 24,
    width: '100%', // Ensure no width constraints
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 0, // Parent already has padding
    marginBottom: 12,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: theme.black, // Dark text in light mode, light text in dark mode
  },
  emptyContainer: {
    paddingTop: 60,
    paddingBottom: 40,
    paddingHorizontal: 40,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  emptyIcon: {
    fontSize: 64,
    marginBottom: 16,
  },
  emptyTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: theme.black, // Dark text in light mode, light text in dark mode
    marginBottom: 12,
    textAlign: 'center',
  },
  emptyText: {
    fontSize: 16,
    color: theme.gray[700], // Gray text that adapts to theme
    fontWeight: '400',
    textAlign: 'center',
    marginBottom: 24,
    paddingHorizontal: 20,
    lineHeight: 22,
  },
  emptyInviteButton: {
    backgroundColor: theme.accent,
    paddingHorizontal: 24,
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 160,
    shadowColor: theme.accent,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 5,
  },
  emptyInviteButtonText: {
    color: '#000000', // Dark text on yellow button
    fontSize: 16,
    fontWeight: '700',
  },
  showMoreButton: {
    backgroundColor: theme.background.card,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    marginTop: 12,
    marginHorizontal: 20,
    borderWidth: 1,
    borderColor: theme.gray[200],
    ...(Platform.OS === 'web' && {
      boxShadow: theme.shadows.card,
    }),
  },
  showMoreText: {
    fontSize: 14,
    color: theme.black, // Dark text in light mode, light text in dark mode
    fontWeight: '600',
  },
  sectionDivider: {
    height: 1,
    backgroundColor: theme.gray[200], // Light gray divider for light background
    marginVertical: 24,
    marginHorizontal: 20,
  },
  filterContainer: {
    flexDirection: 'row',
    paddingHorizontal: 0, // Parent already has padding
    marginBottom: 16,
    gap: 8,
    flexWrap: 'nowrap', // Keep buttons in a single row
    alignItems: 'center',
    width: '100%', // Ensure full width
  },
  filterButton: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: theme.white,
    borderWidth: 1,
    borderColor: theme.gray[300],
    minHeight: 36,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0, // Prevent button from shrinking
    flexGrow: 0, // Prevent button from growing
    ...(Platform.OS === 'web' && {
      boxShadow: theme.shadows.card,
    }),
  },
  filterButtonActive: {
    backgroundColor: theme.primary,
    borderColor: theme.primary,
  },
  filterButtonText: {
    fontSize: 13,
    fontWeight: '600',
    color: theme.black, // Dark text in light mode, light text in dark mode
    flexShrink: 0, // Prevent text from shrinking
  },
  filterButtonTextActive: {
    color: theme.white, // White text on primary background
    fontWeight: '700',
  },
})

// Backward compatibility - export default styles using light theme
export const friendsListStyles = getFriendsListStyles(getTheme('light'))
